<template>
  <MembersTable
    :can-create-member="canManageUsers"
    :can-edit-member="false"
    :can-manage-users="canManageUsers"
    :membership-state="['active', 'pending']"
    :role-items="roleItems"
    :role-key="'deepadmin.users.table.col_role_group'"
    :table-headers="headers"
    ui-context="unit"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { RoleItems } from '@/types/account.ts'
import { ROLE_CODE } from '@deepcloud/api-deep-admin-backend'
import {
  hasUnitAccess,
  useAccountMembershipsContext,
} from '@/composables/deepadmin/use-account-memberships-context.ts'
import { useAccountUnitContext } from '@/composables/deepadmin/use-account-unit-context.ts'
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import MembersTable from '@/components/deepadmin/members/MembersTable.vue'
import type { VDataTable } from 'vuetify/components'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.units.users',
  },
})

const { t } = useI18n()
const { permissions } = useAuthorizationContext()
const { userGroups, selectedOrganizationId } = useAccountMembershipsContext()
const { selectedUnitId } = useAccountUnitContext()

type Headers = VDataTable['$props']['headers']
const headers = computed<Headers>(() => [
  {
    key: 'user',
    title: t('deepadmin.users.table.col_user'),
  },
  {
    key: 'primaryRole.roleCode',
    title: t('deepadmin.users.table.col_role_group'),
  },
  { align: 'end', key: 'actions', title: '', sortable: false },
])

const roleItems = computed<RoleItems>(() => [
  {
    roleName: t('deepadmin.profile.roles.role_names.admin'),
    roleCode: ROLE_CODE.ADMIN,
  },
  {
    roleName: t('deepadmin.profile.roles.role_names.member'),
    roleCode: ROLE_CODE.MEMBER,
  },
])

const canManageUsers = computed(() => {
  return (
    permissions.canManageUsers ||
    hasUnitAccess(
      userGroups.value,
      selectedOrganizationId.value,
      selectedUnitId.value,
    )
  )
})
</script>
